<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
        <div class="row">
            <div class="col-3 d-flex justify-content-start align-items-center">
             
                <span>{{ title }}</span>
            </div>
            <div class="col-6 d-flex meduimname-container">
                <div class="card">
                    <div class="ps-6">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-start">
                                <div class="d-flex centerCnt">
                                    <span [style.background-color]="agentStatusColor" class="dot-circle ms-2"></span> 
                                </div>
                                <div class="label-margin centerCnt" >{{ currStatusLabel }}</div>
                                <span class="status-margin centerCnt">{{ agentStatusDuration }}</span>
                            <!-- </div> -->
                            <!-- <div class="col ms-3 centerCnt"> -->
                                <div *ngIf="liveStatusControls">
                                    <button *ngIf="managerViewBtn" class="outline-btn btn-sm ms-1"
                                            type="submit"
                                            value="Start Live View"
                                            (click)="Startlivemoniter()">
                                        <i class="bi bi-headset"></i> Start Live View
                                    </button>
                                    <button *ngIf="managerListenBtn"
                                            class="outline-btn btn-sm ms-1"
                                            type="submit"
                                            value="Listen In"
                                            (click)="listenInPrep()">
                                        <i class="bi bi-headset"></i> Listen In
                                    </button>
                                    <button *ngIf="managerDisconnectBtn"
                                            class="outline-btn btn-outline-danger btn-sm ms-1"
                                            type="submit"
                                            value="Disconnect"
                                            (click)="listenInStop()">
                                        <i class="bi bi-telephone-x-fill"></i> Disconnect
                                    </button>
                                    <button *ngIf="managerMuteOffBtn"
                                            class="outline-btn btn-outline-default btn-sm ms-1"
                                            type="submit"
                                            value="Unmute"
                                            (click)="eManagerMuteBtnClickHandler()">
                                        <i class="bi bi-mic-mute-fill"></i> Unmute
                                    </button>
                                    <button *ngIf="managerMuteOnBtn"
                                            class="outline-btn btn-outline-default btn-sm ms-1"
                                            type="submit"
                                            value="Mute"
                                            (click)="eManagerMuteBtnClickHandler()">
                                        <i class="bi bi-mic"></i> Mute
                                    </button>
                                    <button *ngIf="managerRemoteLogoffBtn"
                                            class="outline-btn btn-outline-danger btn-sm ms-1"
                                            type="submit"
                                            value="Remote Log Off"
                                            (click)="RemoteLogOff()">
                                        <i class="bi bi-box-arrow-in-left"></i> Remote Log Off
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="btn-grp">
                    <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
                    <input class="main-btn ms-2" [disabled]="!isEnabled" type="submit" value="Save Changes" (click)="saveChanges()" />
                </div>
            </div>
        </div>
    </div>
    <div class="details">
      <div class="text-danger label-error">
        <small  *ngIf="editErrorMessage">{{editErrorMessage}}</small><br>
        <small *ngIf="showExtensionErrorMsg">Onvida Ext: Extension must be a number.</small>
      </div>
      <div class="heading">
        <span class="sub-heading">AGENT DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="col-3 form-group agent-detail-field">
          <div style="opacity: 1">
            <label for="agentName" class="agent-detail-lbl">Name</label>
            <input
              type="text"
              [readonly]="true"
              class="form-control"
              class="inp"
              id="agentName"
              placeholder="Agent Name"
              [value]="agentDetail?.Name"
            />
          </div>
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label for="agentemail" class="agent-detail-lbl">Email</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentemail"
            placeholder="Email"
            [value]="agentDetail?.Email"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label for="agentphone" class="agent-detail-lbl">Phone</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentphone"
            placeholder="Phone"
            [value]="agentDetail?.Phone"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label for="extension" class="agent-detail-lbl">Onvida Ext.</label>
          <input
            type="text"
            [readonly]="false"
            class="form-control"
            class="inp"
            id="extension"
            placeholder="Extn."
            [(ngModel)]="extensionValue"
            [value]="agentDetail?.Extension"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
          <span class="sub-heading">{{queueHeader}}</span>
        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="col-sm-4 form-group agent-detail-field">
          <label for="queueName" class="agent-detail-lbl">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueName"
            placeholder="Queue Name"
            [value]="agentDetail?.LiveStatus?.QueueName"
          />
        </div>

        <div class="col-sm-4 form-group agent-detail-field">
          <label for="queueType" class="agent-detail-lbl">Type</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueType"
            placeholder="Type"
            [value]="agentDetail?.LiveStatus?.QueueType"
          />
        </div>

        <div class="col-sm-4 form-group agent-detail-field">
          <label for="queueLength" class="agent-detail-lbl">Length</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queueLength"
            placeholder="Length"
            [value]="agentDetail?.LiveStatus?.QueueLength"
          />
        </div>
      </div>
    </div>

    <div class="details">
      <div class="heading">
          <span class="sub-heading">{{interactionHeader}}</span>
        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group agent-detail-field">
          <label for="interactioName" class="agent-detail-lbl">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="interactioName"
            placeholder="Queue Name"
            [value]="agentDetail?.LiveStatus?.InteractionUser"
          />
        </div>
        <div class="form-group agent-detail-field">
          <label for="company" class="agent-detail-lbl">Company</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="company"
            placeholder="Type"
            [value]="agentDetail?.LiveStatus?.InteractionCompany"
          />
        </div>
        <div class="form-group agent-detail-field">
          <label for="location" class="agent-detail-lbl">Location</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="location"
            placeholder="Length"
            [value]="agentDetail?.LiveStatus?.InteractionLocation"
          />
        </div>
      </div>
    </div>
    <div class="switch-options">
    <div class="switch-row">
            <p-inputSwitch
              inputId="wrappermode"
              [disabled]="!isEnabled"
              [(ngModel)]="isDesktopOnly"
              styleClass="small-input-switch"
            />
            <label for="wrappermode" class="switch-text">Use wrapper only</label>
    </div>
    <div class="switch-row">
            <p-inputSwitch
              inputId="popups"              
              [disabled]="!isEnabled"
              [(ngModel)]="allowPopUps"
              styleClass="small-input-switch"
            />
            <label class="switch-text">Allow QNXT pop-up</label>
    </div>
    </div>
    <div class="sla-window-ctrls">
      <p-tabView>
        <p-tabPanel header="Queues">
          <p class="p-tab-content">
            <app-assign-agents (modifiedQueueData)="onSelectQueue($event)" [details]="queueDetails"></app-assign-agents>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Skills">
          <p class="p-tab-content">
            <app-assign-agents (modifiedSkillData)="onSelectSkill($event)" [details]="skillDetails"></app-assign-agents>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Interactions">
          <p class="p-tab-content">
            <app-livestatuses-interactions [interactionId]="selectedInteractionId"></app-livestatuses-interactions>
          </p>
        </p-tabPanel>
        <p-tabPanel header="Audits">
          <p class="p-tab-content">
            <app-livestatuses-audits [interactionId]="selectedInteractionId"></app-livestatuses-audits>
          </p>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
